import { Injectable } from '@angular/core';
import { FieldType } from '@sla-ng/ui-material';
import { IReferenceValueDialogLayout } from '../../models/layout/reference-value-layout-dialog.model';
import { IReferenceValueLayout } from '../../models/layout/reference-value-layout.model';
import { CostCenterFacade } from '../facades/master-data/cost-center.facade';

@Injectable({
    providedIn: 'root',
})
export class CostCenterLayoutService {

    constructor(protected myCostCenterFacade: CostCenterFacade) {
    }

    public getReferenceValueLayout(): IReferenceValueLayout {
        return {
            columns: [ 'costAccountingType', 'reference', 'validFrom', 'value', 'actions' ],
            filterFields: [
                {
                    field: 'costAccountingType',
                    label: 'app.model.cost-center-reference-value.cost-accounting-type.label',
                    type: FieldType.select,
                    withClearButton: true,
                    selectData: {
                        displaySearch: true,
                        labelKeys: [ 'name' ],
                        valueKey: 'id',
                        options: this.myCostCenterFacade.fetchCostAccountingTypes(),
                    },
                },
                {
                    field: 'reference',
                    label: 'app.model.cost-center-reference-value.reference.label',
                    type: FieldType.select,
                    withClearButton: true,
                    selectData: {
                        displaySearch: true,
                        labelKeys: [ 'name' ],
                        valueKey: 'id',
                        options: this.myCostCenterFacade.fetchReferences(),
                    },
                },
                {
                    field: 'validity',
                    label: 'app.model.cost-center-reference-value.validity.label',
                    withClearButton: true,
                    type: FieldType.date,
                },
            ],
        };
    }

    public getReferenceValueDialogLayout(): IReferenceValueDialogLayout {
        return {
            addFields: [
                {
                    field: 'costAccountingTypeId',
                    label: 'app.model.cost-center-reference-value.cost-accounting-type.label',
                    type: FieldType.select,
                    selectData: {
                        displaySearch: true,
                        labelKeys: [ 'name' ],
                        valueKey: 'id',
                        options: this.myCostCenterFacade.fetchCostAccountingTypes(),
                    },
                },
                {
                    field: 'referenceId',
                    label: 'app.model.cost-center-reference-value.reference.label',
                    type: FieldType.select,
                    selectData: {
                        displaySearch: true,
                        labelKeys: [ 'name' ],
                        valueKey: 'id',
                        options: this.myCostCenterFacade.fetchReferences(),
                    },
                },
                {
                    field: 'validFrom',
                    label: 'app.model.cost-center-reference-value.validity.label',
                    type: FieldType.date,
                },
                {
                    field: 'amount',
                    label: 'app.model.cost-center-reference-value.wert.label',
                    type: FieldType.decimal,
                },
            ],
            editFields: [
                {
                    field: 'costAccountingTypeId',
                    label: 'app.model.cost-center-reference-value.cost-accounting-type.label',
                    disabled: true,
                    readonly: true,
                    type: FieldType.select,
                    selectData: {
                        displaySearch: true,
                        labelKeys: [ 'name' ],
                        valueKey: 'id',
                        options: this.myCostCenterFacade.fetchCostAccountingTypes(),
                    },
                },
                {
                    field: 'referenceId',
                    label: 'app.model.cost-center-reference-value.reference.label',
                    disabled: true,
                    readonly: true,
                    type: FieldType.select,
                    selectData: {
                        displaySearch: true,
                        labelKeys: [ 'name' ],
                        valueKey: 'id',
                        options: this.myCostCenterFacade.fetchReferences(),
                    },
                },
                {
                    field: 'validFrom',
                    disabled: true,
                    readonly: true,
                    label: 'app.model.cost-center-reference-value.validity.label',
                    type: FieldType.date,
                },
                {
                    field: 'amount',
                    label: 'app.model.cost-center-reference-value.wert.label',
                    type: FieldType.decimal,
                },
            ],
        };
    }
}
